// extracted by mini-css-extract-plugin
export default {"avatarStack":"AssigneesMetadata-module__avatarStack--KLbQ9","avatar":"AssigneesMetadata-module__avatar--b8UaK"};